import { render, staticRenderFns } from "./dialog-login.vue?vue&type=template&id=bf7c742a&scoped=true"
import script from "./dialog-login.vue?vue&type=script&lang=js"
export * from "./dialog-login.vue?vue&type=script&lang=js"
import style0 from "./dialog-login.vue?vue&type=style&index=0&id=bf7c742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c742a",
  null
  
)

export default component.exports